import React, { useCallback } from "react";
import styled from "@mui/material/styles/styled";
import { useScreenSize } from "../util/useScreenSize";
import { IconButton } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { ReactComponent as NewLogoWhiteSvg } from "../../../assets/kahun_new_logo_white.svg";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useHistory } from "react-router-dom";

//region [[ Styles ]]

const KahunWhiteLogo = styled(NewLogoWhiteSvg)({
  width: "70px",
  height: "22px",
});

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "sticky",
  top: "0",
  padding: "20px",
  fontSize: "14px",
  backgroundColor: KahunColorMap.PrimaryDim,
  color: KahunColorMap.Background,
  textAlign: "center",
  whiteSpace: "pre-wrap",
  [theme.breakpoints.down(MobileView)]: {
    padding: "0 20px 20px 20px",
    position: "inherit",
    marginTop: "60px",
  },
}));

const LogoWrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: "20px 0px 12px 0",
  },
}));

const HeaderTitle = styled("div")({
  fontWeight: "bold",
  fontSize: "20px",
});

const MobileBackButton = styled(IconButton)({
  position: "absolute",
  top: "2px",
  left: "0",
});

const MobileBackIcon = styled(KeyboardArrowLeftIcon)({
  color: "white",
  fontSize: "xx-large",
});
//endregion [[ Styles ]]
//region [[ Props ]]
//endregion [[ Props ]]

//region [[ Functions ]]
const HEADER_TITLE = "Patient Summary";
const HEADER_TEXT = `The patient summary includes all patient information entered in Kahun, as well as the suggested assessment and plan.\n Print the summary, or copy it to your clipboard in order to export the information to other apps.`;
//endregion [[ Functions ]]

const ExportDataHeader = () => {
  const { isMobile } = useScreenSize();
  const history = useHistory();

  const handleBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Header>
      <LogoWrapper>
        {isMobile && (
          <MobileBackButton onClick={handleBack}>
            <MobileBackIcon />
          </MobileBackButton>
        )}
        <KahunWhiteLogo />
      </LogoWrapper>
      <HeaderTitle>{HEADER_TITLE}</HeaderTitle>
      <div>{HEADER_TEXT}</div>
    </Header>
  );
};

export default ExportDataHeader;
